import { Version } from '@bmi/version/version';

export const BMI_VERSION = new Version('1.1.1-dev').full;
